import React, { useCallback, useEffect, useState } from "react";
import { useTrail } from "@react-spring/web";
import { Button, useQaLabel, Paragraph } from "@tvg/design-system";
import RunnerResult from "./components/runnerResult";
import ScratchedRunnersResult from "./components/scratchedRunnersResult";
import {
  RaceResultContainer,
  RaceResultHeader,
  RaceResultHeaderBets,
  ButtonContainer,
  RaceResultTextContainer
} from "./styled-components";
import { RaceResultProps } from "./type";
import { numberOfColumnsPayout } from "../utils/numberOfColumnsPayout";

const RaceResult = ({
  runnerResultsList,
  totalPayouts,
  winningTime,
  scratchedRunnersSelection,
  qaLabel = "race-result",
  showMaxResults
}: RaceResultProps) => {
  const [showMore, setShowMore] = useState(false);
  const raceResultQaLabel = useQaLabel(qaLabel);
  const [numberOfColumns, setNumberOfColumn] = useState(0);
  useEffect(() => {
    setNumberOfColumn(numberOfColumnsPayout(totalPayouts));
  }, [totalPayouts]);
  const defaultResultList = runnerResultsList.slice(0, showMaxResults);

  const handleShowMore = useCallback(() => {
    setShowMore((prevState) => !prevState);
  }, []);

  const trail = useTrail(runnerResultsList.length, {
    config: { duration: 50 },
    opacity: showMore ? 1 : 0,
    y: showMore ? 0 : -10,
    from: { opacity: 0, y: -10 }
  });

  return (
    <RaceResultContainer {...raceResultQaLabel}>
      {runnerResultsList.length > 0 && (
        <RaceResultHeader>
          <RaceResultTextContainer>
            <Paragraph qaLabel="position" fontFamily="medium" textAlign="right">
              Position
            </Paragraph>
          </RaceResultTextContainer>
          <RaceResultHeaderBets numberOfColumns={numberOfColumns}>
            {!!totalPayouts.win && (
              <Paragraph
                qaLabel="win-text"
                fontFamily="medium"
                textAlign="right"
              >
                {`${totalPayouts.win} Win`}
              </Paragraph>
            )}
            {!!totalPayouts.place && (
              <Paragraph
                qaLabel="place-text"
                fontFamily="medium"
                textAlign="right"
              >
                {`${totalPayouts.place} Place`}
              </Paragraph>
            )}

            {!!totalPayouts.show && (
              <Paragraph
                qaLabel="show-text"
                fontFamily="medium"
                textAlign="right"
              >
                {`${totalPayouts.show} Show`}
              </Paragraph>
            )}
          </RaceResultHeaderBets>
        </RaceResultHeader>
      )}

      {showMore
        ? trail.map((styles, index) => (
            <RunnerResult
              {...runnerResultsList[index as number]}
              key={`runner-result-${index.toString()}`}
              animatedStyles={index + 1 > showMaxResults ? styles : {}}
            />
          ))
        : defaultResultList.map((runnerResult, index) => (
            <RunnerResult
              {...runnerResult}
              key={`runner-result-${index.toString()}`}
            />
          ))}

      {showMaxResults < runnerResultsList.length && (
        <ButtonContainer>
          <Button
            variant="tertiary"
            onPress={handleShowMore}
            qaLabel="show-more-runners"
            icon={showMore ? "chevronUp" : "chevronDown"}
            iconPosition="end"
            p="space-4"
          >
            {showMore ? "See less" : `See ${runnerResultsList.length} runners`}
          </Button>
        </ButtonContainer>
      )}

      {(winningTime || scratchedRunnersSelection.length > 0) && (
        <ScratchedRunnersResult
          winningTime={winningTime}
          scratchedRunnersSelection={scratchedRunnersSelection}
        />
      )}
    </RaceResultContainer>
  );
};

export default RaceResult;
